import React from 'react';
import { Tooltip } from '@barracuda-internal/bds-core-v2';

export const SearchEndAdornment: React.FC<{
  searchValue: string;
  isSearchFocused: boolean;
  scanlogsSearchFields: string[];
}> = ({ isSearchFocused, scanlogsSearchFields }) => (
  <Tooltip
    title={
      <span style={{ padding: '4px', display: 'block' }}>
        {`Joe or <field>:<text> where field can be ${scanlogsSearchFields.join(', ')}`}
      </span>
    }
    open={isSearchFocused}
    placement="bottom"
    arrow
    slotProps={{
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: { offset: [0, 10] },
          },
        ],
      },
    }}
  >
    <span style={{ display: 'inline', width: '100%', position: 'absolute' }} />
  </Tooltip>
);
